import type { Network } from "../types";

export const x: Network = {
  name: "X",
  shareUrl: "https://x.com/intent/post?url=[u]",
  args: {
    title: "&text=[t]",
    user: "&via=[uid]",
    hashtags: "&hashtags=[h]",
  },
  icon: "/media/images/social-share-x.png",
  color: "#000000",
};
